import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableHiddenFilterPipe } from './table-hidden-filter.pipe';



@NgModule({
  declarations: [TableHiddenFilterPipe],
  imports: [
    CommonModule
  ],
  exports: [TableHiddenFilterPipe]
})
export class TableHiddenFilterModule { }
